<form [formGroup]="courseForm" (ngSubmit)="saveCourse(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i
                class="bx bx-book-reader me-1 font-20 text-primary"></i>{{courseForm.value.id?'Update':'Add'}}
            Training
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal"
            aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3 mb-2">
            <div class="col-md-5">
                <label for="name" class="form-label">Name <b
                        class="text-secondary">*</b></label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-user'></i></span>

                    <input type="text" class="form-control" id="name"
                        formControlName="name" ngbAutofocus
                        [ngClass]="{'is-invalid': submitted && f.name.errors}"
                        placeholder="Enter Name" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.name.errors">
                        <span *ngIf="f.name.errors.required">Course name is
                            required.</span>
                            <span *ngIf="f.name.errors.pattern">Course name must be 1-250 chars.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <label for="label" class="form-label">Description</label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-file'></i></span>

                    <input type="text" class="form-control" id="label"
                        formControlName="label"
                        [ngClass]="{'is-invalid': submitted && f.label.errors}"
                        placeholder="Enter Description" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.label.errors">
                        <span *ngIf="f.label.errors.required">Description is
                            required.</span>
                            <span *ngIf="f.label.errors.pattern">Description must be 1-250 chars.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <label for="code" class="form-label">Code <b
                        class="text-secondary">*</b></label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-barcode'></i></span>

                    <input type="text" class="form-control" id="code"
                        formControlName="code"
                        [ngClass]="{'is-invalid': submitted && f.code.errors}"
                        placeholder="Enter Code"
                        [value]="f['code'].value | uppercase" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.code.errors">
                        <span *ngIf="f.code.errors.required">Course code is
                            required.</span>
                            <span *ngIf="f.code.errors.pattern">Code must be alphanumeric.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <label for="duration" class="form-label">Duration (in days) <b
                        class="text-secondary">*</b></label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-time'></i></span>

                    <input type="number" class="form-control" id="duration"
                        formControlName="duration"
                        [ngClass]="{'is-invalid': submitted && f.duration.errors}"
                        placeholder="Duration" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.duration.errors">
                        <span *ngIf="f.duration.errors.required">Duration is
                            required.</span>
                        <span *ngIf="f.duration.errors.min">Duration must be at
                            least 1 day.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <label for="credits" class="form-label">Credits <b
                        class="text-secondary">*</b></label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-award'></i></span>

                    <input type="number" class="form-control" id="credits"
                        formControlName="credits"
                        [ngClass]="{'is-invalid': submitted && f.credits.errors}"
                        placeholder="Credits" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.credits.errors">
                        <span *ngIf="f.credits.errors.required">Credits are
                            required.</span>
                        <span *ngIf="f.credits.errors.min">Credits cannot be
                            negative.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="free"
                        formControlName="free">
                    <label class="form-check-label" for="hasTest">Free</label>
                </div>
            </div>
            <div class="col-md-2">
                <label for="fee" class="form-label">Course Fee <b
                        class="text-secondary">*</b></label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-rupee'></i></span>

                    <input type="number" class="form-control" id="fee"
                        formControlName="fee"
                        [readonly]="courseForm.value.free"
                        [ngClass]="{'is-invalid': submitted && f.fee.errors}"
                        placeholder="Fee" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.fee.errors">
                        <span *ngIf="f.fee.errors.required">Course Fee is
                            required.</span>
                        <span *ngIf="f.fee.errors.min">Course Fee cannot be
                            negative.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="hasTest"
                        formControlName="hasTest">
                    <label class="form-check-label" for="hasTest">Has
                        Test</label>
                </div>
            </div>
            <div class="col-md-2">
                <label for="maxRetries" class="form-label">Max Retries</label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-repeat'></i></span>

                    <input type="number" class="form-control" id="maxRetries"
                        formControlName="maxRetries"
                        [readonly]="!courseForm.value.hasTest"
                        [ngClass]="{'is-invalid': submitted && f.maxRetries.errors}"
                        placeholder="Max Retries" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.maxRetries.errors">
                        <span *ngIf="f.maxRetries.errors.required">MaxRetries is
                            required.</span>
                        <span *ngIf="f.maxRetries.errors.min">MaxRetries 
                             cannot be negative.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <label for="retryDays" class="form-label">Retry Days</label>
                <div class="input-group ">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-calendar-check'></i></span>

                    <input type="number" class="form-control" id="retryDays"
                        formControlName="retryDays"
                        [readonly]="!courseForm.value.hasTest"
                        [ngClass]="{'is-invalid': submitted && f.retryDays.errors}"
                        placeholder="Retry Days" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.retryDays.errors">
                        <span *ngIf="f.retryDays.errors.required">RetryDays Fee
                            is required.</span>
                        <span *ngIf="f.retryDays.errors.min">RetryDays cannot be negative
                            .</span>
                    </div>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox"
                        id="recertificationRequired"
                        formControlName="recertificationRequired">
                    <label class="form-check-label"
                        for="recertificationRequired">Recertification</label>
                </div>
            </div>
            <div class="col-md-2">
                <label for="recertifyPeriod" class="form-label">
                    Period (in months)</label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-calendar-check'></i></span>

                    <input type="number" class="form-control"
                        id="recertifyPeriod" formControlName="recertifyPeriod"
                        [readonly]="!courseForm.value.recertificationRequired"
                        [ngClass]="{'is-invalid': submitted && f.recertifyPeriod.errors}"
                        placeholder="Period" />
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.recertifyPeriod.errors">
                        <span
                            *ngIf="f.recertifyPeriod.errors.required">Recertify
                            Period is required.</span>
                        <span *ngIf="f.recertifyPeriod.errors.min">Recertify
                            Period cannot be negative.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <label for="questionCount" class="form-label">Count</label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-hash'></i></span>
                    <input type="number" class="form-control" id="questionCount" formControlName="questionCount"
                        readonly [ngClass]="{'is-invalid': submitted && f.questionCount.errors}"
                        placeholder="Enter Count" />
                    <div class="invalid-feedback" *ngIf="submitted && f.questionCount.errors">
                        <span *ngIf="f.questionCount.errors.required">Question Count are required.</span>
                        <span *ngIf="f.questionCount.errors.min">Question Count cannot be negative.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <label for="status" class="form-label">Status<b
                        class="text-secondary">*</b></label>
                <div class="input-group">
                    <span
                        class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-layer'></i></span>
                    <ng-select class="form-control rcx-ng-select"
                        formControlName="courseStatus" [clearable]="false"
                        placeholder="Select Status"
                        [ngClass]="{'is-invalid': submitted && f.courseStatus.errors}">
                        <ng-option *ngFor=" let status of statuses;"
                            [value]="status">{{status}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback"
                        *ngIf="submitted && f.courseStatus.errors">
                        <span *ngIf="f.courseStatus.errors.required">Please
                            select a status .</span>
                    </div>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox"
                        id="disabled" formControlName="disabled">
                    <label class="form-check-label"
                        for="disabled">Disabled</label>
                </div>
            </div>
            <div class="col-lg-auto ms-auto">
                <button type="submit" class="btn btn-secondary rcx-btn"
                    #inProgress
                    [ngClass]="{'no-event':inProgress?.value=='true'}">
                    <ng-container *ngIf="inProgress?.value=='true'">
                        <span class="spinner-border spinner-border-sm"
                            role="status" aria-hidden="true"></span>
                        {{courseForm.value.id?'Updating...':'Saving...'}}
                    </ng-container>
                    <ng-container *ngIf="inProgress?.value!='true'">
                        <i
                            class="bx bx-save"></i>{{courseForm.value.id?'Save Changes':'Save'}}
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</form>
<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive"
                        *ngIf="courseForm?.value?.id">
                        <h5 class="modal-title d-flex align-items-center">
                            <i
                                class="bx bx-list-ul me-1 font-20 text-primary"></i>Course
                            Slides
                        </h5>
                        <form [formGroup]="courseSlideForm ">
                            <table class="table" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light">
                                        <th scope="col" width="70"
                                            data-bs-toggle="tooltip"
                                            title="Title of the slide"
                                            class="th-slide">
                                            <span
                                                class="d-flex align-items-center">
                                                <i
                                                    class="bx bx-book-reader me-1 font-20"></i>
                                                Title <b
                                                    class="text-secondary">*</b>
                                            </span>
                                        </th>
                                        <th scope="col" width="300"
                                            data-bs-toggle="tooltip"
                                            class="th-slide"
                                            title="Main content of the slide">
                                            <span
                                                class="d-flex align-items-center">
                                                <i
                                                    class="bx bx-align-left me-1 font-20 "></i>
                                                Content <b
                                                class="text-secondary">*</b>
                                            </span>
                                        </th>
                                        <th scope="col" width="100"
                                            data-bs-toggle="tooltip"
                                            title="Order of the slide"
                                            class="th-slide">
                                            <span
                                                class="d-flex align-items-center">
                                                <i
                                                    class="bx bx-sort me-1 font-20 "></i>
                                                Sequence <b
                                                    class="text-secondary">*</b>
                                            </span>
                                        </th>
                                        <th scope="col" width="200"
                                            data-bs-toggle="tooltip"
                                            class="th-slide"
                                            title="Link to Slide Media">
                                            <span
                                                class="d-flex align-items-center">
                                                <i
                                                    class="bx bx-image me-1 font-20 "></i>Image
                                            </span>
                                        </th>
                                        <th scope="col" width="100"
                                            data-bs-toggle="tooltip"
                                            class="th-slide"
                                            title="Enable or disable slide">
                                            <span
                                                class="d-flex align-items-center">
                                                <i
                                                    class="bx bx-toggle-left me-1 font-20 "></i>
                                                Disabled
                                            </span>
                                        </th>
                                        <th scope="col" width="160"
                                            class="text-center"
                                            data-bs-toggle="tooltip"
                                            class="th-slide"
                                            title="Available actions">
                                            <span
                                                class="d-flex align-items-center justify-content-center">
                                                <i
                                                    class="bx bx-cog me-1 font-20"></i>
                                                Actions
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="courseSlides">
                                    <tr
                                        *ngFor="let courseSlide of courseSlides.controls; let i=index"
                                        [formGroupName]="i">
                                        <td class="col-lg-4 px-0">
                                            <input type="text"
                                                class="form-control form-control-sm"
                                                formControlName="title"
                                                placeholder="Title" required>
                                        </td>
                                        <td class="col-lg-4">
                                            <textarea
                                                class="form-control form-control-sm"
                                                formControlName="content"
                                                placeholder="Content" required
                                                cols="1" rows="1"></textarea>
                                        </td>
                                        <td class="col-lg-2">
                                            <input type="number"
                                                class="form-control form-control-sm"
                                                formControlName="sequence"
                                                placeholder="Sequence" required>
                                        </td>
                                        <td class="col-lg-2">
                                            <button type="button"
                                                class="btn btn-sm truncate-text d-flex align-items-center gap-0"
                                                accept=".jpg, .jpeg, .png,"
                                                [ngClass]="courseSlide.value.mediaUrl ? 'btn-primary' : 'btn-secondary'"
                                                (click)="courseSlide.value.mediaUrl ? previewImage(i) : triggerFileInput(i)">

                                                <i
                                                    [ngClass]="courseSlide.value.mediaUrl ? 'bx bx-show' : 'bx bx-file'"></i>

                                                <span class="truncate-label">
                                                    {{
                                                    courseSlide.value.mediaUrl ?
                                                    'View Slide' :
                                                    courseSlide.value.fileName
                                                    || 'Choose File' }}
                                                </span>
                                            </button>

                                            <input type="file" #fileInput    accept=".jpg, .jpeg, .png,"
                                                (change)="!courseSlide.value.mediaUrl && onFileSelected($event, i,courseSlide.value)"
                                                style="display:none;" />
                                        </td>
                                        <td class="col-lg-2">
                                            <input type="checkbox"
                                                formControlName="disabled"
                                                class="form-check-input">
                                            <label
                                                class="form-check-label ms-2">Disabled</label>
                                        </td>
                                        <td class="actions">
                                            <i
                                                class="{{ courseSlide?.value?.id ? 'bx bx-edit' : 'bx bx-save' }} alert-primary mt-1"
                                                title="{{ courseSlide?.value?.id ? 'Update Course Slide' : 'Save Course Slide' }}"
                                                *ngIf="!courseSlide?.isUpdateInProgress"
                                                (click)="upsertCourseSlide(courseSlide, i)">
                                            </i>
                                            <div
                                                *ngIf="courseSlide?.isUpdateInProgress"
                                                role="status"
                                                class="spinner-border spinner-border-sm text-primary">
                                                <span
                                                    class="visually-hidden">Loading...</span>
                                            </div>
                                            <i
                                                *ngIf="!courseSlide?.isDeleteInProgress && courseSlides.controls.length > 1 && courseSlide.value.id"
                                                title="Delete Course Slide"
                                                class="bx bx-trash alert-secondary mt-1"
                                                (click)="deleteCourseSlide(courseSlide,i)"></i>
                                            <div
                                                *ngIf="courseSlide?.isDeleteInProgress"
                                                role="status"
                                                class="spinner-border spinner-border-sm text-danger">
                                                <span
                                                    class="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>